export default {"src":"/_next/static/media/scheidsrechter.0436e4ca.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};